// Its own leaf module (no imports) so outside consumers don't have to import FilterDrawer.tsx itself.
export const preDefinedAttributes = {
    newsToggles: 'preDefinedNewsToggles',
    stockAvailability: 'preDefinedStockAvailability',
};
